"use client";

import { NewArticlePopupModel } from "@api/models";
import Link from "next/link";
import Image from "next/image";
import { useStaticStore } from "app/hooks";
import { STORE_KEYS } from "app/constants";
import { MdClose } from "react-icons/md";

export function PopupContentNewArticle({ content }: { content: NewArticlePopupModel }) {
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.popup);
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <div className="dialog-content">
      <h2 className="dialog-h">新エピソードのお知らせ</h2>
      <p className="dialog-desc">
        {content.isRental && "レンタルしたことがある"}『{content.seriesName}
        』の新しいエピソードが公開されています
      </p>
      <div className="dialog-main">
        <Link href={content.episodeUrl || ""} className="dialog-main-link" autoFocus>
          <h3 className="dialog-main-link-h">{content.articleTitle}</h3>
          {content.largeImageUrl && (
            <figure className="dialog-main-fig">
              <Image
                className="dialog-main-img"
                src={content.largeImageUrl || content.thumbnailImageUrl || ""}
                width={1200}
                height={630}
                alt={content.articleTitle ? content.articleTitle + "の画像" : ""}
              />
            </figure>
          )}
          <span className="dialog-main-btn">読む</span>
        </Link>
      </div>
      <button className="dialog-close" onClick={handleClose}>
        <MdClose aria-label="閉じる" size={24} className="dialog-close-icon" />
      </button>
      <div className="dialog-f">
        <button className="dialog-f-btn" onClick={handleClose}>
          閉じる
        </button>
      </div>
    </div>
  );
}
